<mat-card class="clientPanel">
  <div class="panelHeader">
    <div class="clientBadge"><mat-icon>person</mat-icon>Клиент №{{ client?.id }}</div>
    <button class="editClientButton" color="primary" mat-stroked-button (click)="edit()" [disabled]="phoneActionLoading">
      <mat-icon>edit</mat-icon>
      Изменить
    </button>
  </div>

  <mat-card-content class="panelContent">
    <section class="summarySection">
      <h1 class="clientName">{{ client?.name || '—' }}</h1>
      <div class="clientMeta">
        <span class="metaChip" *ngIf="phones.length">{{ phones.length }} тел.</span>
        <span class="metaChip" *ngIf="client?.cars?.length">{{ client?.cars?.length }} авто</span>
        <span class="metaChip" [class.metaChipMuted]="client?.smsNotificationsEnabled === false">
          SMS {{ client?.smsNotificationsEnabled === false ? 'выкл' : 'вкл' }}
        </span>
        <span
          class="metaChip"
          *ngIf="client?.paymentDelayDays !== null && client?.paymentDelayDays !== undefined"
        >
          Отсрочка {{ client?.paymentDelayDays }} дн.
        </span>
        <span
          class="metaChip"
          *ngIf="client?.debtLimit !== null && client?.debtLimit !== undefined"
        >
          Лимит {{ supportService.formatMoney(client?.debtLimit || 0) }}
        </span>
      </div>
    </section>

    <section class="phonesSection">
      <div class="sectionHeader">
        <div class="sectionTitleGroup">
          <mat-icon class="sectionIcon">phone</mat-icon>
          <div class="sectionTitle">Телефоны</div>
          <span class="sectionCounter" *ngIf="phones.length">{{ phones.length }}</span>
        </div>
      </div>

      <div class="phonesBody">
        <div class="phoneRows" *ngIf="phones.length > 0; else emptyPhones">
          <div class="phoneRow" *ngFor="let phone of phones">
            <div class="phoneData" *ngIf="editingPhoneId !== phone.id">
              <span class="phoneValue">{{ formatPhone(phone.phone) }}</span>
              <span class="primaryBadge" *ngIf="phone.isPrimary">Основной</span>
            </div>

            <div class="phoneEdit" *ngIf="editingPhoneId === phone.id">
              <mat-form-field appearance="outline">
                <mat-label>Телефон</mat-label>
                <input matInput [formControl]="editPhoneFormControl" mask="(000) 000 00 00" />
              </mat-form-field>
              <div class="phoneEditActions">
                <button mat-flat-button color="primary" (click)="savePhone(phone.id)" [disabled]="phoneActionLoading || editPhoneFormControl.invalid || !editPhoneFormControl.value">
                  Сохранить
                </button>
                <button mat-stroked-button type="button" (click)="cancelEditPhone()">Отмена</button>
              </div>
            </div>

            <div class="phoneActions" *ngIf="editingPhoneId !== phone.id">
              <button
                mat-icon-button
                type="button"
                class="callPhoneButton"
                [disabled]="callingPhoneId !== null"
                matTooltip="Позвонить через Ringostat"
                [attr.aria-label]="'Позвонить: ' + formatPhone(phone.phone)"
                (click)="clickToCall(phone)"
              >
                <mat-icon *ngIf="callingPhoneId !== phone.id">call</mat-icon>
                <mat-spinner *ngIf="callingPhoneId === phone.id" diameter="18"></mat-spinner>
              </button>
              <button
                mat-icon-button
                aria-label="Сделать основным"
                matTooltip="Сделать основным"
                *ngIf="!phone.isPrimary"
                (click)="makePrimary(phone.id)" [disabled]="phoneActionLoading"
              >
                <mat-icon>star</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="Редактировать телефон"
                matTooltip="Редактировать телефон"
                (click)="startEditPhone(phone)" [disabled]="phoneActionLoading"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                aria-label="Удалить телефон"
                matTooltip="Удалить телефон"
                (click)="removePhone(phone.id)" [disabled]="phoneActionLoading"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <ng-template #emptyPhones>
          <div class="emptyState">Телефоны не добавлены</div>
        </ng-template>
      </div>

      <div class="addPhoneRow">
        <mat-form-field appearance="outline">
          <mat-label>Новый телефон</mat-label>
          <input
            matInput
            [formControl]="addPhoneFormControl"
            mask="(000) 000 00 00"
            (keyup.enter)="addPhone()"
          />
          <button
            mat-icon-button
            matSuffix
            color="primary"
            type="button"
            class="inlineAddPhoneButton"
            aria-label="Добавить номер"
            (click)="addPhone()" [disabled]="phoneActionLoading || addPhoneFormControl.invalid || !addPhoneFormControl.value"
          >
            <mat-icon>add_circle</mat-icon>
          </button>
        </mat-form-field>
      </div>
    <small class="phoneHint">Изменения телефонов сохраняются сразу.</small></section>
    <section class="responsibleSection">
      <div class="sectionHeader">
        <div class="sectionTitleGroup">
          <mat-icon class="sectionIcon">support_agent</mat-icon>
          <div>
            <div class="sectionTitle">Ответственный менеджер</div>
            <div class="sectionSubtle">
              {{ client?.responsibleManager?.name || 'Не назначен' }}
            </div>
          </div>
        </div>
      </div>

      <div class="responsibleRow">
        <app-user-selector [control]="responsibleManagerControl"></app-user-selector>
        <div class="responsibleActions">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="saveResponsibleManager()"
            [disabled]="responsibleManagerSaving"
          >
            <mat-spinner *ngIf="responsibleManagerSaving" [diameter]="18"></mat-spinner>
            <mat-icon *ngIf="!responsibleManagerSaving">save</mat-icon>
            Сохранить
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="clearResponsibleManager()"
            [disabled]="responsibleManagerSaving || !client?.responsibleManager"
          >
            <mat-icon>close</mat-icon>
            Сбросить
          </button>
        </div>
      </div>
    </section>
  </mat-card-content>
</mat-card>
